module.exports = __webpack_public_path__ + "static/img/img(18).bdecf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(18).png
// module id = gHzg
// module chunks = 1